export interface Article {
  id: number;
  title: string;
  category: string;
  excerpt: string;
  content: string;
  image: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
}

export interface CategoryInfo {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: CategoryInfo[] = [
  {
    slug: 'latest',
    name: '最新内容',
    description: '蜜桃传媒最新发布的内容更新，第一时间掌握精彩资讯',
    icon: 'ri-flashlight-line',
  },
  {
    slug: 'exclusive',
    name: '独家资源',
    description: '蜜桃传媒独家策划与制作的高品质原创内容',
    icon: 'ri-vip-crown-line',
  },
  {
    slug: 'featured',
    name: '精品推荐',
    description: '编辑精选的优质内容，汇聚蜜桃传媒平台上的口碑佳作',
    icon: 'ri-star-line',
  },
  {
    slug: 'popular',
    name: '热门排行',
    description: '用户最喜爱的热门内容排行，发现大家都在看的精彩作品',
    icon: 'ri-fire-line',
  },
  {
    slug: 'members',
    name: '会员专区',
    description: '蜜桃传媒会员专属的精品内容与服务，尊享极致体验',
    icon: 'ri-shield-star-line',
  },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '2024年度精品内容创作趋势深度解析：品质与创新的双重突破',
    category: 'featured',
    excerpt: '随着内容消费升级，蜜桃传媒深入分析2024年精品内容创作的最新趋势，从制作水准、叙事创新到用户体验，全面解读行业的变革方向。',
    content: `<p>在数字内容消费日益精细化的今天，精品内容创作正在经历一场深刻的变革。蜜桃传媒作为行业领先的内容平台，持续关注并推动这一趋势的发展。</p>
    <h2>品质化：从量到质的根本转变</h2>
    <p>过去几年，内容平台普遍追求数量扩张，但2024年的趋势清晰地指向了品质化方向。用户不再满足于泛泛而谈的内容，而是期待更高制作水准、更深度的叙事体验。蜜桃传媒在这一趋势中率先布局，通过严格的品质把控和专业的制作团队，确保每一部作品都能达到行业领先水准。</p>
    <p>品质化的核心体现在三个层面：首先是视觉呈现的精细化，从画面构图到色彩调校，每个细节都经过精心打磨；其次是叙事结构的创新，打破传统的线性叙事，引入更多元的表达方式；最后是用户体验的沉浸感营造，让观众不只是观看者，更是参与者。</p>
    <h2>创新驱动：技术与内容的深度融合</h2>
    <p>技术创新正在重塑精品内容的创作方式。从拍摄设备到后期制作，从分发渠道到互动体验，技术在各个环节发挥着关键作用。蜜桃传媒积极拥抱新技术，不断探索内容表达的新可能。</p>
    <p>值得注意的是，技术只是手段而非目的。真正打动人心的内容，永远是那些能够触及情感、引发共鸣的作品。蜜桃传媒始终保持内容为本的理念，让技术服务于故事，而非喧宾夺主。</p>
    <h2>多元化内容生态的构建</h2>
    <p>单一类型的内容已无法满足日益多元的用户需求。蜜桃传媒致力于构建丰富的内容矩阵，覆盖多个领域和风格，确保不同兴趣的用户都能在平台上找到心仪的作品。</p>
    <p>展望未来，蜜桃传媒将继续坚持品质与创新并重的发展策略，为用户提供更优质、更多元的内容体验，引领行业向更高标准迈进。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20content%20creation%20studio%20with%20warm%20lighting%20and%20sophisticated%20camera%20equipment%20on%20wooden%20desk%2C%20soft%20coral%20and%20gold%20accent%20decor%2C%20editorial%20photography%20style%2C%20clean%20minimal%20background%20with%20subtle%20warm%20gradients%2C%20professional%20creative%20workspace%20atmosphere&width=800&height=500&seq=article-1&orientation=landscape',
    author: '蜜桃编辑部',
    date: '2024-12-15',
    views: 128560,
    tags: ['内容趋势', '精品创作', '行业分析', '品质提升'],
  },
  {
    id: 2,
    title: '探寻华语精品短剧的崛起：小而美的内容革命',
    category: 'featured',
    excerpt: '精品短剧正成为华语内容市场的新宠。蜜桃传媒独家解析这一现象背后的创作逻辑与市场机遇。',
    content: `<p>在华语内容市场的版图上，精品短剧正在开辟一片全新的疆域。不同于传统长篇剧集的宏大叙事，精品短剧以其精炼的篇幅、紧凑的节奏和高密度的情感冲击，赢得了越来越多用户的青睐。</p>
    <h2>短剧为什么能赢？</h2>
    <p>现代用户的时间越来越碎片化，但审美要求却越来越高。短剧恰好满足了这一矛盾需求——在有限的时间内提供高质量的完整体验。蜜桃传媒敏锐地捕捉到这一趋势，率先布局精品短剧领域。</p>
    <p>短剧的精髓在于"少即是多"。每集时长虽短，但信息密度和情感浓度必须足够。这对创作团队提出了更高的要求：必须在有限的时间内完成人物塑造、情节推进和情感传达。</p>
    <h2>精品化之路</h2>
    <p>不是所有短剧都是精品。蜜桃传媒在短剧创作中坚持高标准的品质要求，从剧本打磨到后期制作，每一个环节都精益求精。我们相信，只有真正优质的内容，才能在激烈的市场竞争中脱颖而出。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Artistic%20film%20set%20with%20warm%20cinematic%20lighting%20and%20professional%20video%20equipment%2C%20soft%20coral%20and%20warm%20neutral%20tones%2C%20elegant%20minimalist%20studio%20atmosphere%2C%20creative%20production%20environment%20with%20sophisticated%20aesthetic&width=800&height=500&seq=article-2&orientation=landscape',
    author: '蜜桃编辑部',
    date: '2024-12-10',
    views: 95320,
    tags: ['短剧', '华语内容', '精品制作', '市场趋势'],
  },
  {
    id: 3,
    title: '蜜桃传媒会员专属剧集《暗夜之光》上线首周即破百万播放',
    category: 'members',
    excerpt: '蜜桃传媒全新会员专属原创剧集《暗夜之光》震撼上线，凭借扣人心弦的剧情和精良的制作，首周播放量突破百万。',
    content: `<p>蜜桃传媒倾力打造的会员专属原创剧集《暗夜之光》于本月正式上线，一经播出便引发热烈反响，首周播放量突破百万大关，成为平台当季最受关注的作品之一。</p>
    <h2>匠心制作，品质保证</h2>
    <p>《暗夜之光》从立项到上线历时18个月，汇聚了业内顶尖的编剧、导演和制作团队。每一帧画面都经过精心打磨，每一段配乐都量身定制，力求为观众带来影院级的观影体验。</p>
    <p>故事围绕一位调查记者的冒险旅程展开，融合了悬疑、情感和社会议题等多重元素，既有扣人心弦的剧情张力，也有引人深思的社会关怀。</p>
    <h2>会员专享，尊贵体验</h2>
    <p>作为蜜桃传媒会员专属内容，《暗夜之光》为会员用户提供了包括4K超清画质、杜比全景声、幕后花絮等在内的多项专属权益。蜜桃传媒始终致力于为会员打造超越期待的内容体验。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20noir%20style%20urban%20night%20scene%20with%20warm%20golden%20street%20lights%20and%20mysterious%20atmosphere%2C%20elegant%20film%20noir%20aesthetic%20with%20soft%20shadows%2C%20sophisticated%20cinematography%20style%2C%20warm%20coral%20and%20deep%20neutral%20tones&width=800&height=500&seq=article-3&orientation=landscape',
    author: '蜜桃传媒原创',
    date: '2024-12-08',
    views: 1002500,
    tags: ['会员专享', '原创剧集', '暗夜之光', '热播推荐'],
  },
  {
    id: 4,
    title: '幕后纪实：蜜桃传媒制作团队的一天',
    category: 'exclusive',
    excerpt: '跟随镜头走进蜜桃传媒的制作幕后，揭秘精品内容从创意到成品的完整诞生过程。',
    content: `<p>每一部精品内容的背后，都有一个默默付出的制作团队。今天，我们带您走进蜜桃传媒的制作幕后，见证创意如何一步步转化为屏幕上的精彩。</p>
    <h2>清晨：创意的萌芽</h2>
    <p>每天早上九点，蜜桃传媒的创意团队准时开始一天的头脑风暴。从选题讨论到脚本构思，每一个想法都被认真对待和充分探讨。创意总监表示："我们鼓励团队成员大胆表达，因为最好的创意往往来自最自由的碰撞。"</p>
    <h2>午后：精雕细琢的执行</h2>
    <p>当创意方向确定后，制作团队进入高强度的工作模式。从场景搭建到灯光调试，从演员指导到镜头调度，每个环节都体现着专业与专注。</p>
    <h2>深夜：后期打磨的艺术</h2>
    <p>当大多数人已经休息，蜜桃传媒的后期团队仍在为每一个画面精益求精。剪辑师需要在海量素材中找到最佳的表达方式，调色师则为画面赋予独特的情感色调。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20creative%20production%20team%20working%20in%20a%20modern%20studio%20with%20warm%20lighting%2C%20professional%20film%20equipment%20and%20monitors%2C%20collaborative%20creative%20atmosphere%2C%20sophisticated%20editorial%20photography%20with%20soft%20coral%20and%20warm%20neutral%20tones&width=800&height=500&seq=article-4&orientation=landscape',
    author: '蜜桃纪实',
    date: '2024-12-05',
    views: 67890,
    tags: ['幕后纪实', '制作团队', '独家内容', '创作故事'],
  },
  {
    id: 5,
    title: '蜜桃传媒2025年内容战略发布：三大赛道全面发力',
    category: 'latest',
    excerpt: '蜜桃传媒正式发布2025年度内容战略，将在原创剧集、精品短剧和纪录片三大赛道全面发力。',
    content: `<p>蜜桃传媒今日正式发布2025年度内容战略规划，宣布将在原创剧集、精品短剧和纪录片三大核心赛道全面发力，为用户带来更丰富多元的精品内容体验。</p>
    <h2>原创剧集：IP矩阵持续扩展</h2>
    <p>2025年，蜜桃传媒计划推出超过20部原创剧集，涵盖悬疑、都市、古装、科幻等多个题材。其中多部作品已经进入制作阶段，预计将在明年上半年陆续与观众见面。</p>
    <h2>精品短剧：打造差异化竞争优势</h2>
    <p>短剧赛道是蜜桃传媒2025年的重点发力方向。平台将投入专项资源，扶持优秀创作团队，打造具有鲜明特色的精品短剧品牌。</p>
    <h2>纪录片：用真实打动人心</h2>
    <p>蜜桃传媒还将加大对纪录片的投入，聚焦人文、自然、科技等主题，用真实的故事和精美的画面，为观众带来知识与美感的双重享受。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20strategy%20presentation%20scene%20with%20warm%20elegant%20atmosphere%2C%20sophisticated%20conference%20room%20with%20soft%20lighting%2C%20professional%20creative%20business%20setting%2C%20warm%20coral%20and%20neutral%20color%20palette%2C%20editorial%20photography%20style&width=800&height=500&seq=article-5&orientation=landscape',
    author: '蜜桃编辑部',
    date: '2024-12-01',
    views: 45670,
    tags: ['内容战略', '2025规划', '原创剧集', '平台发展'],
  },
  {
    id: 6,
    title: '用户口碑精选：2024年最受好评的十部蜜桃传媒作品',
    category: 'popular',
    excerpt: '基于海量用户评价数据，蜜桃传媒揭晓2024年度最受好评的十部作品榜单。',
    content: `<p>岁末年终，蜜桃传媒基于平台海量用户的真实评价数据，正式揭晓2024年度用户口碑精选榜单。这份榜单汇聚了过去一年中最受用户喜爱的十部精品佳作。</p>
    <h2>榜单评选机制</h2>
    <p>本次评选综合了用户评分、完播率、互动数据和口碑传播等多个维度，力求全面反映用户的真实喜好。蜜桃传媒始终坚持数据驱动的评价体系，确保榜单的公正性和权威性。</p>
    <h2>上榜作品亮点</h2>
    <p>从悬疑惊悚到温馨治愈，从都市情感到历史传奇，上榜作品展现了令人惊叹的题材多样性和创作水准。每一部作品都在各自的领域内实现了突破，为观众带来了独特的观看体验。</p>
    <p>蜜桃传媒感谢每一位创作者的用心付出，也感谢每一位用户的支持与陪伴。2025年，我们将继续携手前行，共创更多精彩。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20scene%20with%20warm%20golden%20lighting%20and%20sophisticated%20atmosphere%2C%20minimalist%20design%20with%20trophy%20elements%2C%20soft%20coral%20accents%2C%20professional%20editorial%20photography%20with%20refined%20aesthetic&width=800&height=500&seq=article-6&orientation=landscape',
    author: '蜜桃编辑部',
    date: '2024-11-28',
    views: 156780,
    tags: ['口碑榜单', '年度精选', '用户评价', '精品推荐'],
  },
  {
    id: 7,
    title: '蜜桃传媒会员权益全面升级：解锁更多专属体验',
    category: 'members',
    excerpt: '蜜桃传媒宣布会员权益全面升级，新增多项专属特权，为用户打造更尊贵的娱乐体验。',
    content: `<p>蜜桃传媒今日宣布会员权益体系全面升级。此次升级涵盖内容、画质、互动和服务四大维度，为会员用户带来前所未有的尊贵体验。</p>
    <h2>内容特权：先看、独看、多看</h2>
    <p>升级后的会员权益包括：所有原创内容提前48小时观看、每月新增5部会员专属作品、以及海量经典内容库的无限畅看。蜜桃传媒持续扩充会员专属内容库，确保会员用户始终有新鲜内容可以探索。</p>
    <h2>品质特权：视听双重升级</h2>
    <p>会员用户将享受4K超高清画质和杜比全景声的顶级视听体验。同时，平台还推出了智能推荐增强功能，基于会员的观看偏好提供更精准的内容推荐。</p>
    <h2>互动特权：与创作者零距离</h2>
    <p>新增的会员互动特权包括：独家线上见面会、幕后花絮观看权、以及投票决定未来内容方向的参与权。蜜桃传媒希望每一位会员不仅是内容的消费者，更是内容生态的共建者。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Luxury%20membership%20experience%20scene%20with%20warm%20golden%20and%20coral%20accents%2C%20elegant%20VIP%20atmosphere%2C%20sophisticated%20home%20theater%20setting%20with%20soft%20lighting%2C%20premium%20entertainment%20experience%2C%20editorial%20photography%20style&width=800&height=500&seq=article-7&orientation=landscape',
    author: '蜜桃传媒',
    date: '2024-11-20',
    views: 89200,
    tags: ['会员权益', '服务升级', '专属体验', 'VIP'],
  },
  {
    id: 8,
    title: '对话蜜桃传媒创始人：我们为什么坚持做精品内容',
    category: 'exclusive',
    excerpt: '蜜桃传媒创始人接受独家专访，深入分享平台创立的初心、发展历程以及对精品内容创作的执着追求。',
    content: `<p>在内容行业浮躁逐利的当下，蜜桃传媒始终坚持精品化路线。为此，我们独家专访了蜜桃传媒创始人，听他讲述平台背后的故事与信念。</p>
    <h2>创立的初心</h2>
    <p>"内容本身是有力量的。"创始人回忆道，"我们希望创建一个平台，让优质内容能够被更多人看到，让创作者能够专注于创作本身，而不必为流量焦虑。"带着这样的初心，蜜桃传媒从一个小小的内容工作室起步，逐步成长为今天的综合性媒体平台。</p>
    <h2>坚守精品化</h2>
    <p>在"流量为王"的时代浪潮中，蜜桃传媒选择了一条不同的道路。"我们宁可慢一点，也要确保每一部作品都对得起观众的期待。"这种对品质的坚守，在短期内或许不是最优的商业选择，但从长远来看，却为蜜桃传媒赢得了用户的信任和口碑。</p>
    <h2>未来的愿景</h2>
    <p>谈到未来，创始人充满信心："蜜桃传媒将继续坚持精品化路线，同时拥抱技术创新，为用户带来更多惊喜。我们的目标不仅仅是做一个内容平台，更是成为华语精品内容的标杆。"</p>`,
    image: 'https://readdy.ai/api/search-image?query=Professional%20founder%20interview%20scene%20in%20warm%20elegant%20office%20setting%2C%20sophisticated%20modern%20workspace%20with%20bookshelves%20and%20soft%20natural%20light%2C%20warm%20coral%20and%20neutral%20tones%2C%20editorial%20portrait%20photography%20style&width=800&height=500&seq=article-8&orientation=landscape',
    author: '蜜桃专访',
    date: '2024-11-15',
    views: 72340,
    tags: ['创始人专访', '品牌故事', '精品内容', '独家访谈'],
  },
];

export const brandInfo = {
  name: '蜜桃传媒',
  fullName: '蜜桃传媒文化传播有限公司',
  slogan: '专注优质内容创作与传播',
  description: '蜜桃传媒是国内领先的精品内容创作与传播平台，致力于为用户提供高品质的娱乐内容体验。自成立以来，蜜桃传媒始终坚持"内容为王、品质至上"的核心理念，汇聚业内顶尖创作人才，打造了一系列深受用户喜爱的精品力作。',
  mission: '以匠心精神创作每一部作品，用优质内容丰富每个人的精神世界。',
  vision: '成为华语世界最具影响力的精品内容平台。',
  founded: '2018年',
  location: '中国·北京',
  contact: {
    email: 'contact@mitaomedia.com',
    phone: '400-888-9999',
    address: '北京市朝阳区建国路88号蜜桃传媒大厦',
    wechat: 'mitaomedia_official',
    weibo: '@蜜桃传媒官方',
  },
  stats: [
    { label: '原创作品', value: '500+' },
    { label: '活跃用户', value: '2000万+' },
    { label: '合作创作者', value: '3000+' },
    { label: '获奖荣誉', value: '120+' },
  ],
  timeline: [
    { year: '2018', event: '蜜桃传媒正式成立，开启精品内容创作之路' },
    { year: '2019', event: '推出首部原创剧集，获得行业高度关注' },
    { year: '2020', event: '用户突破500万，完成A轮融资' },
    { year: '2021', event: '上线会员服务体系，开启商业化新篇章' },
    { year: '2022', event: '平台用户突破1500万，荣获多项行业大奖' },
    { year: '2023', event: '推出精品短剧赛道，全年上线100+原创作品' },
    { year: '2024', event: '用户突破2000万，确立行业领先地位' },
  ],
};

export const faqItems = [
  {
    question: '蜜桃传媒会员有哪些权益？',
    answer: '蜜桃传媒会员享有独家内容提前观看、4K超高清画质、杜比全景声、会员专属剧集、幕后花絮、线上见面会等多项专属权益。会员体系分为月度会员和年度会员，年度会员可享更多优惠。',
  },
  {
    question: '如何成为蜜桃传媒的创作者？',
    answer: '您可以通过蜜桃传媒官网的"创作者入驻"页面提交申请，我们的内容团队会在7个工作日内进行审核。我们欢迎有才华、有创意的内容创作者加入蜜桃传媒大家庭。',
  },
  {
    question: '蜜桃传媒支持哪些设备观看？',
    answer: '蜜桃传媒支持Web网页端、iOS App、Android App、智能电视（TV版）以及平板电脑等多种设备，让您随时随地享受精品内容。',
  },
  {
    question: '如何联系蜜桃传媒的客服？',
    answer: '您可以通过以下方式联系我们：客服热线 400-888-9999、官方邮箱 contact@mitaomedia.com，或在蜜桃传媒App内使用在线客服功能。我们的客服团队7×24小时为您服务。',
  },
  {
    question: '蜜桃传媒的内容更新频率是怎样的？',
    answer: '蜜桃传媒保持高频内容更新，原创剧集每周更新2-3集，精品短剧每日上新，纪录片和专题内容每周更新。会员内容更有独家提前观看特权。',
  },
];